import { render, staticRenderFns } from "./CreateProductForm.vue?vue&type=template&id=63a1e685&scoped=true"
import script from "./CreateProductForm.vue?vue&type=script&lang=js"
export * from "./CreateProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1e685",
  null
  
)

export default component.exports